import Axios from 'axios';

// API target comes from .env (REACT_APP_API_URL), which differs by branch:
//   master  → https://aceit-api-569487920686.us-east1.run.app  (prod — live student data)
//   develop → https://api-dev.acecsec.com                      (dev — aceit_dev_db)
// Local backend override: set REACT_APP_API_URL=http://192.168.133.125:8080 in .env.local
// Fallback is prod so a missing .env can never silently point a deploy at dev.

const BASE_URL =
  process.env.REACT_APP_API_URL || 'https://aceit-api-569487920686.us-east1.run.app';

export const ADMIN_KEY_STORAGE = 'aceit-admin-key';

const axios = Axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

axios.interceptors.request.use(config => {
  const key = localStorage.getItem(ADMIN_KEY_STORAGE);
  if (key) {
    config.headers['X-Admin-Key'] = key;
  }
  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(ADMIN_KEY_STORAGE);
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axios;
